/* Trendora mobile variant and bundle UX fixes */
(function () {
  function resetOptionalBundleItems() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    Array.prototype.slice.call(document.querySelectorAll('.n9-fbt-add-checkbox')).forEach(function (input, index) {
      if (index === 0 || !input.checked) return;
      input.checked = false;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  resetOptionalBundleItems();
  if (document.body) {
    var observer = new MutationObserver(resetOptionalBundleItems);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 8000);
  }
}());
(function () {
  var inlineProps = ['position','top','right','bottom','left','width','max-width','max-height','transform','z-index','opacity','visibility','pointer-events'];
  var openSequence = 0;
  function opened() { return Array.prototype.slice.call(document.querySelectorAll('.t4s-dropdown__wrapper.is--opened')); }
  function wrapperFor(trigger) {
    var id = trigger && trigger.getAttribute('data-id');
    return id && document.getElementById(id);
  }
  function sync() {
    if (window.innerWidth > 767) return;
    var list = opened();
    list.forEach(function (wrapper) {
      wrapper.style.position = 'absolute'; wrapper.style.top = '40px'; wrapper.style.right = '0';
      wrapper.style.bottom = 'auto'; wrapper.style.left = '0'; wrapper.style.width = '100%';
      wrapper.style.maxWidth = 'none'; wrapper.style.maxHeight = '65vh';
      wrapper.style.transform = 'none'; wrapper.style.zIndex = '1001';
      wrapper.style.opacity = '1'; wrapper.style.visibility = 'visible'; wrapper.style.pointerEvents = 'auto';
    });
    var overlay = document.querySelector('.t4s-close-overlay');
    if (overlay && list.length) overlay.style.zIndex = '1000';
  }
  function schedule() { [0,40,120,250,500].forEach(function (delay) { window.setTimeout(sync, delay); }); }
  function ensureOpen(trigger) {
    var sequence = ++openSequence;
    var id = trigger && trigger.getAttribute('data-id');
    if (!id) return;
    [80,220,450].forEach(function (delay) {
      window.setTimeout(function () {
        if (sequence !== openSequence) return;
        var wrapper = document.getElementById(id);
        if (!wrapper || wrapper.classList.contains('is--opened')) { sync(); return; }
        wrapper.classList.add('is--opened');
        var overlay = document.querySelector('.t4s-close-overlay');
        if (overlay) {
          overlay.classList.remove('t4s-op-0');
          overlay.classList.add('is--visible', 'is--pindop');
        }
        sync();
      }, delay);
    });
  }
  function hide(wrapper) {
    if (!wrapper) return;
    wrapper.classList.remove('is--opened');
    inlineProps.forEach(function (prop) { wrapper.style.removeProperty(prop); });
    var button = wrapper.parentElement && wrapper.parentElement.querySelector('button.is--clicked');
    if (button) button.classList.remove('is--clicked');
  }
  function closeAfterSelection() {
    openSequence++;
    [0,120,300].forEach(function (delay) { window.setTimeout(function () {
      Array.prototype.slice.call(document.querySelectorAll('.t4s-dropdown__wrapper')).forEach(function (wrapper) {
        var style = getComputedStyle(wrapper);
        if (wrapper.classList.contains('is--opened') || style.opacity !== '0' && style.pointerEvents !== 'none') hide(wrapper);
      });
      var overlay = document.querySelector('.t4s-close-overlay');
      if (overlay && !document.querySelector('.t4s-dropdown__wrapper.is--opened')) {
        overlay.classList.remove('is--visible'); overlay.classList.add('t4s-op-0'); overlay.style.removeProperty('z-index');
      }
    }, delay); });
  }
  function triggerFrom(event) { return event.target && event.target.closest && event.target.closest('.t4s-swatch__list > button'); }
  document.addEventListener('pointerup', function (event) {
    var trigger = triggerFrom(event);
    if (trigger) { schedule(); ensureOpen(trigger); }
  }, true);
  document.addEventListener('touchend', function (event) {
    var trigger = triggerFrom(event);
    if (trigger) { schedule(); ensureOpen(trigger); }
  }, true);
  document.addEventListener('click', function (event) {
    var trigger = triggerFrom(event);
    if (trigger) { schedule(); ensureOpen(trigger); }
    if (event.target && event.target.closest && event.target.closest('.t4s-dropdown__wrapper .t4s-swatch__item')) closeAfterSelection();
  }, true);
  function closeAll() {
    openSequence++;
    Array.prototype.slice.call(document.querySelectorAll('.t4s-dropdown__wrapper')).forEach(function (wrapper) {
      hide(wrapper);
    });
    var overlay = document.querySelector('.t4s-close-overlay');
    if (overlay) {
      overlay.classList.remove('is--visible', 'is--pindop');
      overlay.classList.add('t4s-op-0');
      overlay.style.removeProperty('z-index');
    }
  }
  function dismissFrom(event) {
    if (!opened().length) return;
    var target = event.target;
    var closeTarget = target && target.closest && target.closest('[data-dropdown-close], .t4s-close-overlay');
    var optionTarget = target && target.closest && target.closest('.t4s-dropdown__wrapper.is--opened .t4s-swatch__item');
    var triggerTarget = triggerFrom(event);
    var pointInside = opened().some(function (wrapper) {
      var rect = wrapper.getBoundingClientRect();
      return event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
    });
    if (closeTarget) {
      event.preventDefault();
      event.stopPropagation();
      closeAll();
      return;
    }
    if (optionTarget || triggerTarget || pointInside) return;
    var insideWrapper = target && target.closest && target.closest('.t4s-dropdown__wrapper.is--opened');
    if (!insideWrapper) {
      event.preventDefault();
      event.stopPropagation();
      closeAll();
    }
  }
  ['pointerup', 'touchend', 'click'].forEach(function (eventName) {
    document.addEventListener(eventName, dismissFrom, true);
  });
  sync();
}());